jQuery('a#scroll_down').on('click', function(e){
    e.preventDefault();
    var element = jQuery(this).closest("main").find(".home-top");
    jQuery("body").animate({
        scrollTop: jQuery(element).offset().top
    }, 1000);
    return false;
});